import { stringToBytes } from '../encoding/toBytes.js';
export function packetToBytes(packet) {
    function length(value) {
        if (value === '.' || value === '..')
            return 1;
        return stringToBytes(value.replace(/^\.|\.$/gm, '')).length + 2;
    }
    const bytes = new Uint8Array(length(packet));
    const value = packet.replace(/^\.|\.$/gm, '');
    if (!value.length)
        return bytes;
    let offset = 0;
    const list = value.split('.');
    for (let i = 0; i < list.length; i++) {
        const encoded = stringToBytes(list[i]);
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    return bytes;
}
//# sourceMappingURL=packetToBytes.js.map